import { useKeycloak } from "@react-keycloak/web";
import { DashboardFilters } from "../components/DashboardFilters";
import { MapPage } from "../components/Map";
import { useNavigate } from "react-router-dom";

import { useEnrichedProjects, useProjectsPage, useRiskFilteredProjects } from "../state/projects";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

export const DashboardPage = (
  { showMenu, setShowMenu, mapReload }:
    { showMenu: boolean, setShowMenu?: React.Dispatch<React.SetStateAction<boolean>>, mapReload?: boolean }
) => {
  const navigate = useNavigate();
  const { keycloak: { token } } = useKeycloak();
  const { loadProjectsPage } = useProjectsPage();
  // Shared enrichment: projects merged with their action items, identical to the
  // data the Projects list view filters on (keeps the risk filter consistent).
  const enrichedProjects = useEnrichedProjects();
  const [riskLevelFilter, setRiskLevelFilter] = useState<string>('all');
  // Risk matches and per-project counts come from the backend, not from the client-side list.
  const riskFiltered = useRiskFilteredProjects(riskLevelFilter);
  const [viewMode, setViewMode] = useState<'map' | 'projects'>('map');

  useEffect(() => {
    async function loadProjects() {
      try {
        await loadProjectsPage(1);
      } catch (error) {
        toast.error('Failed to load projects', {
          toastId: 'failed-to-load-projects'
        });
        console.error(error);
      }
    }
    if (token) {
      loadProjects();
    }
  }, [token]);


  const handleRiskLevelFilter = (riskLevel: string) => {
    setRiskLevelFilter(riskLevel);
  };

  const handleViewChange = (view: 'map' | 'projects') => {
    if (view === 'projects') {
      // Navigate to projects list page
      navigate('/projects');
    } else {
      // Stay on map view
      setViewMode(view);
    }
  };

  
  return (
    <div className="relative w-full h-screen">
      {!mapReload && (
        <div className="absolute inset-0 z-0">
          {viewMode === 'map' ? (
            <MapPage
              servers={enrichedProjects}
              riskServers={riskFiltered.projects}
              riskCounts={riskFiltered.counts}
              showMenu={showMenu}
              riskFilter={riskLevelFilter}
              onRiskFilter={handleRiskLevelFilter}
            />
          ) : (
            // List view should redirect to projects page, not show "Coming soon"
            // This case should not happen since List view navigates to /projects
            <div className="w-full h-full bg-[#f5f5f5] flex items-center justify-center">
              <div className="text-center">
                <div className="text-[#888] text-lg mb-2">Redirecting to Projects...</div>
              </div>
            </div>
          )}
        </div>
      )}
      
      {/* Dashboard Filters - show for map and projects views */}
      {(viewMode === 'map' || viewMode === 'projects') && (
        <div className="relative z-10">
          <DashboardFilters
            setShowMenu={setShowMenu}
            showMenu={showMenu}
            view={viewMode}
            onViewChange={handleViewChange}
            onPriorityFilter={handleRiskLevelFilter}
            selectedRiskLevel={riskLevelFilter}
          />
        </div>
      )}
    </div>
  );
};
